<template lang="html">
  <div>
    <div class="graph-title">{{ title }}</div>
    <div class="graph-menu">
      <v-radio-group v-model="normalization" row>
        <v-radio label="Totaal" value="absolute"></v-radio>
        <v-radio label="Per inwoner" value="perInhabitant"></v-radio>
      </v-radio-group>
    </div>
    <horizontal-bar-chart v-if="chartData" :chart-data="chartData" />
  </div>
</template>

<script>
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
export default {
  data: () => ({
    normalization: "" //either "absolute" or "perInhabitant"
  }),
  props: {
    title: String,
    variable: String,
    perInhabitant: Boolean
  },
  mounted() {
    this.normalization = this.perInhabitant ? "perInhabitant" : "absolute";
  },
  components: {
    HorizontalBarChart
  },
  computed: {
    nrInhabitantsColumnName() {
      return this.indicator ? this.indicator["veld aantal inwoners"] : null;
    },
    indicators() {
      return this.$store.getters.indicators;
    },
    indicator() {
      return this.indicators.find(i => i.variabele == this.variable);
    },
    data_deelregios() {
      return this.$store.getters.data_deelregios;
    },
    chartData() {
      if (!this.data_deelregios || !this.nrInhabitantsColumnName) return null;
      const indicatorValues = Object.entries(this.data_deelregios)
        .map(([regio, valueList]) => {
          let value =
            this.normalization == "absolute"
              ? valueList[this.variable]
              : valueList[this.variable] /
                valueList[this.nrInhabitantsColumnName];
          if (value > 10) {
            value = Math.round(value);
          } else if (value > 0.01) {
            value = Math.round(value * 100) / 100;
          } else {
            value = Math.round(value * 1000000) / 1000000;
          }
          return {
            regio: regio,
            value: value
          };
        })
        .sort((d1, d2) => d2.value - d1.value);
      return {
        labels: indicatorValues.map(i => i.regio),
        datasets: [
          {
            label: this.indicator ? this.indicator.omschrijving : "",
            backgroundColor: "#ec0000",
            data: indicatorValues.map(i => i.value),
            perInhabitant: this.perInhabitant //used for formatting tooltip
          }
        ]
      };
    }
  }
};
</script>

<style lang="css" scoped>
.graph-title {
  font-size: 1.1em;
  font-weight: bold;
}
</style>
